import React, {
	forwardRef, useImperativeHandle, useState, useMemo,
} from 'react';
import _ from 'lodash';

export const ResultContext = React.createContext({});

const ResultManager = forwardRef(({ children }, ref) => {
	const [score, setScore] = useState({
		firstSection: {},
		middleSection: {},
		lastSection: {},
	});
	const firstSectionTotal = _.sum(_.values(score.firstSection));
	const middleSectionTotal = _.sum(_.values(score.middleSection));
	const lastSectionTotal = _.sum(_.values(score.lastSection));
	const totalScore = firstSectionTotal + middleSectionTotal + lastSectionTotal;
	useImperativeHandle(ref, () => ({
		getTotalScore: () => totalScore,
	}));
	const contextValue = useMemo(() => ({
		score, setScore, totalScore, firstSectionTotal, middleSectionTotal, lastSectionTotal,
	})
	// eslint-disable-next-line
	, [totalScore])
	return (
		<ResultContext.Provider value={contextValue}>
			{children}
		</ResultContext.Provider>
	);
});

export default ResultManager;
